// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__16f6r","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2EkMm"};